import * as _ from 'underscore';
import { DevicePickerBar } from '../../app/content/devicePreview/deviceBar/DevicePickerBar';
import { UserAgentSupport } from '../../common/utilities/UserAgentSupport';
import { Order } from '../helpers/Order';
import { DeviceType } from '../models/DeviceType';
import { IViewBase, IViewDetailInfo, IViewInfo } from '../models/IViewInfo';
import { IViz, VizType } from '../models/Viz';
import { Module } from '../Module';
import { Views } from '../resources/Views';
import { DevicePreviewService } from '../services/DevicePreviewService';
import { ErrorState } from '../services/ErrorState';
import { ServerService } from '../services/ServerService';
import { VizService } from '../services/VizService';

export interface IVizProperties {
  view?: IViewBase;
}

export interface IVizPreviewScope extends ng.IScope {
  viz: IViz;
  vizProps: IVizProperties;
  devicePickerBarProps: DevicePickerBar.Props;
  hasError: () => boolean;
  isTouch: () => boolean;
  onVizInitialized: () => void;
  vizInitialized: boolean;
  vizPath: string;
}

export class VizPreviewCtrl {

  public static $inject = [
    '$scope',
    '$q',
    'ErrorState',
    'DevicePreviewService',
    'ServerService',
    'VizService',
    'Views',
  ];

  private hasError: boolean;
  private hasViewError: boolean = false;

  constructor(
    private $scope: IVizPreviewScope,
    private $q: ng.IQService,
            errorState: ErrorState,
    private devicePreviewService: DevicePreviewService,
    private server: ServerService,
            vizService: VizService,
    private views: Views,
  ) {
    if (!devicePreviewService.isEnabled()) {
      errorState.go({
        detailsLocKey: 'pageDoesNotExist',
        redirectLocKey: 'backToContent'
      });
    }

    // Initial viz state
    $scope.viz = {
      path: $scope.vizPath,
      vizType: VizType.DeviceVizPreview,
      params: vizService.getVizParams(),
      siteUrlName: server.sessionSiteUrlName(),
      instanceId: vizService.getInstanceId(),
      isExplicitOriginalViz: vizService.getIsExplicitOriginalViz(),
      allowReloadViz: true
    };

    $scope.onVizInitialized = () => $scope.vizInitialized = true;

    this.$scope.devicePickerBarProps = {
      onDeviceTypeClick: (device: DeviceType) => {
        const previewDevice: DeviceType = this.devicePreviewService.changePreviewDevice(device);
        if (previewDevice) {
          this.handleDeviceChange(previewDevice);
        }
      },
      selectedDevice: this.devicePreviewService.getPreviewDevice(),
    };

    this.initializeNavigationToolsPropsOnScope();

    $scope.$watch('viz.isExplicitOriginalViz', (isExplicitOriginalViz: boolean) => {
      vizService.updateExplicitOriginalViz($scope, isExplicitOriginalViz);
    });

    $scope.isTouch = () => UserAgentSupport.isTouch();
  }

  private initializeNavigationToolsPropsOnScope() {
    this.views.getByPath(this.$scope.viz.path)
    .then((viewInfo: IViewDetailInfo) => {
      const orderClause = [ Order.asc('index') ];
      const viewsQuery = this.views.forWorkbook(viewInfo.workbook).withOrder(orderClause);

      const viewsForWorkbook = viewsQuery.getCount()
      .then((viewCount) => viewsQuery.getSlice(0, viewCount))
      .then((result) => result.items);

      return this.$q.all({
        views: viewsForWorkbook,
        currentViewId: viewInfo.id
      });
    })
    .then(({ views, currentViewId }: { views: IViewInfo[], currentViewId: string }) => {
      this.$scope.devicePickerBarProps = {
        ...this.$scope.devicePickerBarProps,
        navigationToolsProps: this.buildNavigationToolsProps(views, currentViewId)
      };
    });
  }

  // public for testing purposes only
  public buildNavigationToolsProps(viewList: IViewInfo[], currentViewId: string) {
    const indexOfCurrentView = viewList.findIndex(view => view.id === currentViewId);

    return {
      viewList: viewList,
      startingViewIndex: (indexOfCurrentView !== -1 ? indexOfCurrentView : 0),
      onNewViewSelected: (newView: IViewInfo) => {
        this.handleChangedPath(newView.path);
      }
    };
  }

  private handleDeviceChange(device: DeviceType) {
    this.$scope.$apply(() =>
      this.$scope.devicePickerBarProps = _.extend({}, this.$scope.devicePickerBarProps, {
        selectedDevice: device
      })
    );
    this.$scope.viz.reloadViz();
  }

  private handleChangedPath(newPath: string) {
    this.$scope.$apply(() =>
      this.$scope.viz.path = newPath
    );
    this.$scope.viz.reloadViz();
  }

}

Module.instance().controller('VizPreviewCtrl', VizPreviewCtrl);
